import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import * as func from "../../../common/manipurCommon/FunctionCalls";
import * as api from "../../../common/manipurCommon/API";
import Utils from "../../../common/manipurCommon/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const CenterAtheleteApprove = () => {

    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [centerList, setCenterList] = useState<any[]>([]);
    const [batchList, setBatchList] = useState<any[]>([]);
    const [coachList, setCoachList] = useState<any[]>([]);
    const [hpcList, setHPCList] = useState<any[]>([]);
    const [athleteId, setAthleteId] = useState("");
    const [centerId, setCenterId] = useState("");
    const [batchId, setBatchId] = useState("");
    const [coachId, setCoachId] = useState("");
    const [hpcId, setHpcId] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [showTable, setShowTable] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchCenterList() {
            setIsLoading(true);
            const centersResponse = await func.listGeoCenters();
            setCenterList(Array.isArray(centersResponse) ? centersResponse : [])
            setIsLoading(false);
        }
        fetchCenterList();
    }, [])

    const filteredData = athleteList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const athleteNameRender = (rowData) => {
        return <span>{rowData.athleteName}</span>
    };

    const editDetails = (rowData) => {
        return (
            <Button className="btn-secondary" onClick={() => approveAthlete(rowData)}>
                <i className="feather-check"></i>Approve
            </Button>
        );
    };

    async function showAthleteList(btchId: string) {

        const athletesResponse = await func.centerBatchAthletes(centerId, btchId);
        setAthleteList(Array.isArray(athletesResponse) ? athletesResponse : [])
        setShowTable(true);
    }

    async function approveAthlete(rowData: { userId: any; }) {
        const hpcResponse = await func.hpc(null);
        setHPCList(Array.isArray(hpcResponse) ? hpcResponse : [])
        const coachResponse = await func.listCoaches();
        setCoachList(Array.isArray(coachResponse) ? coachResponse : [])
        setAthleteId(rowData.userId)
        setOpenModal(true)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            const formData = new FormData();
            formData.append("hpcId", hpcId);
            formData.append("coachId", coachId);
            formData.append("userId", athleteId);
            const approveAthlt = api.ApproveAthleteToHPC;
            fetch(approveAthlt, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
        }
    }
    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Approve Athletes</h4>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Center</label>
                                        <Select
                                            value={centerList.find(cntr => cntr.geoCenterId === centerId) ? {
                                                value: centerId,
                                                label: centerList.find(cntr => cntr.geoCenterId === centerId).geoCenterName
                                            } : null}
                                            onChange={async (e) => {
                                                setCenterId(e.value);
                                                const batchResponse = await func.centerBatch(null);
                                                setBatchList(Array.isArray(batchResponse) ? batchResponse : [])
                                            }}
                                            required
                                            placeholder="Select Center"
                                            options={centerList.map(cntr => ({
                                                value: cntr.geoCenterId,
                                                label: cntr.geoCenterName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Batch</label>
                                        <Select
                                            value={batchList.find(bch => bch.centerBatchId === batchId) ? {
                                                value: batchId,
                                                label: batchList.find(bch => bch.centerBatchId === batchId).centerBatchName
                                            } : null}
                                            onChange={async (e) => {
                                                setBatchId(e.value);
                                                showAthleteList(e.value);
                                            }}
                                            required
                                            placeholder="Select Batch"
                                            options={batchList.map(bch => ({
                                                value: bch.centerBatchId,
                                                label: bch.centerBatchName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                            </div>
                            {showTable && (
                                <>
                                    <div className="col-lg-12 col-sm-12 mb-10 text-end dataTables_filter">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                style={{ height: "40px" }}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                    <div className="tab-content">
                                        <div
                                            className="tab-pane fade show active"
                                            id="nav-Recent"
                                            role="tabpanel"
                                            aria-labelledby="nav-Recent-tab"
                                            tabIndex={0}
                                        >
                                            <div className="table-responsive table-datatble">
                                                <DataTable
                                                    className="table datatable"
                                                    value={filteredData}
                                                    paginator
                                                    rows={10}
                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                    // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                    pageLinkSize={3}
                                                >
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="slNo"
                                                        body={slNoRender}
                                                        header="Sl &nbsp; No"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="firstName"
                                                        header="Athlete Name"
                                                        body={athleteNameRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {openModal && (
                <Modal
                    size="sm"
                    show={openModal}
                    centered>
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case">Assign to HPC</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <form ref={formRef}>
                            <div className="row">
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">HPC</label>
                                        <Select
                                            value={hpcList.find(hpc => hpc.geoHPCId === hpcId) ? {
                                                value: hpcId,
                                                label: hpcList.find(hpc => hpc.geoHPCId === hpcId).geoHPCName
                                            } : null}
                                            onChange={async (e) => {
                                                setHpcId(e.value);
                                                const coachResponse = await func.listCoaches();
                                                setCoachList(Array.isArray(coachResponse) ? coachResponse : [])
                                            }}
                                            required
                                            placeholder="Select HPC"
                                            options={hpcList.map(hpc => ({
                                                value: hpc.geoHPCId,
                                                label: hpc.geoHPCName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Coach Name</label>
                                        <Select
                                            value={coachList.find(coch => coch.userId === coachId) ? {
                                                value: coachId,
                                                label: coachList.find(coch => coch.userId === coachId).coachName
                                            } : null}
                                            onChange={async (e) => {
                                                setCoachId(e.value);
                                            }}
                                            required
                                            placeholder="Select Coach"
                                            options={coachList.map(coch => ({
                                                value: coch.userId,
                                                label: coch.coachName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                            </div>
                            <ModalFooter>
                                <Button
                                    className="btn-primary text-uppercase"
                                    variant="success"
                                    type="submit"
                                    onClick={handleSubmit}
                                >
                                    <b><i className="fas fa-save" />Save</b>
                                </Button>
                            </ModalFooter>
                        </form>
                    </ModalBody>
                </Modal>
            )}
        </>
    );
};

export default CenterAtheleteApprove;